import {RefObject} from 'preact';

import {BrandHandle} from 'utilities/delivery-promise';

interface BrandImageProps {
  isVisible: boolean;
  onClick: () => void;
  logoSrc: string;
  logoAltText: string;
  brandHandle?: BrandHandle;
  learnMoreReturnFocusRef?: RefObject<HTMLElement>;
}

export function BrandImage({
  isVisible,
  onClick,
  logoSrc,
  logoAltText,
  brandHandle,
  learnMoreReturnFocusRef,
}: BrandImageProps) {
  return (
    <button
      type="button"
      aria-haspopup="true"
      aria-expanded={isVisible}
      onClick={onClick}
      ref={learnMoreReturnFocusRef as RefObject<HTMLButtonElement>}
    >
      <img src={logoSrc} alt={logoAltText} data-brand-handle={brandHandle} />
    </button>
  );
}
